import {
  Component,
  computed,
  inject,
  input,
} from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-dashboard-content',
  imports: [
    MatIcon,
  ],
  styles: `
    :host {
      display: block;
      height: 100%;

      iframe, .dashboard-placeholder {
        display: block;
        height: 100%;
        width: 100%;
      }

      .dashboard-placeholder {
        background-color: #1f272d;

        .data-icon {
          color: white;
          height: 100%;
          margin: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  `,
  template: `
    @if (safeDashboardUrl()) {
      <iframe [src]="safeDashboardUrl()" [title]="title()"></iframe>
    } @else {
      <div class="dashboard-placeholder">
        <span class="data-icon">
          <mat-icon fontIcon="dashboard" />
        </span>
      </div>
    }
  `,
})
export class DashboardContentComponent {
  private readonly sanitizer = inject(DomSanitizer)

  readonly url = input.required<string>()
  readonly title = input.required<string>()

  protected readonly safeDashboardUrl = computed((): SafeResourceUrl | undefined =>
    this.url() ? this.sanitizer.bypassSecurityTrustResourceUrl(this.url()) : undefined,
  )
}
